import { Component, HostListener, Input, OnInit } from '@angular/core';
import { ulid } from 'ulid';
import { TekinputService } from '../../service/tekinput.service';
import { Category } from '@tekman/onmat/service/onmat';

@Component({
  selector: 'tekarea',
  templateUrl: './tekarea.component.html',
  styleUrls: ['./tekarea.component.scss'],
})
export class TekareaComponent implements OnInit {
  @Input() isTeacher = true;
  @Input() validated = false;
  @Input() disabled = false;
  @Input() categoryid = Category.EJERCICIOS;
  @Input() value = '';
  @Input() controlName = '';
  @Input() order = 0;
  category: typeof Category = Category;

  id: string;
  tooltipText: string;

  constructor(private readonly tekInputService: TekinputService) {}

  ngOnInit(): void {
    this.tooltipText = this.isTeacher ? 'f.activity.tekarea.teacher' : 'f.activity.tekarea.student';
    this.id = ulid();
  }

  tooltipFollowCursor(e: MouseEvent): void {
    const tooltip = document.getElementById(`tooltip-${this.id}`);
    tooltip.style.position = 'absolute';
    tooltip.style.left = e.offsetX.toString() + 'px';
    tooltip.style.top = e.offsetY.toString() + 'px';
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: any) {
    this.tekInputService.setIsEditingInput(true);
  }
}
